import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  scroll(event) {
    const id = event.currentTarget.getAttribute("href")?.slice(1)
    if (!id) return
    const target = document.getElementById(id)
    if (!target) return
    event.preventDefault()
    target.scrollIntoView({ behavior: "smooth", block: "start" })
  }
}
